import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowRight, Gift, Heart, Sparkles } from 'lucide-react';
export function PersonalizedGiftsPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-563">
      <Header data-id="element-564" />

      <main className="flex-grow" data-id="element-565">
        {/* Hero */}
        <section className="bg-gradient-to-br from-pink-500 to-rose-500 text-white py-20 md:py-32" data-id="element-566">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-567">
            <h1 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-568">
              Unique Personalized Gifts
            </h1>
            <p className="text-xl text-pink-100 max-w-3xl mx-auto mb-10" data-id="element-569">
              Create one-of-a-kind treasures for the people you love. From
              custom mugs to monogrammed bags, give a gift that truly means
              something.
            </p>
            <a href="/contact" className="inline-flex items-center px-8 py-4 bg-white text-pink-600 font-bold rounded-full shadow-lg hover:bg-gray-50 transition-all transform hover:-translate-y-1" data-id="element-570">
              Get a Quote
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-571" />
            </a>
          </div>
        </section>

        {/* Gift Ideas */}
        <section className="py-20" data-id="element-572">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-573">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-574">
              <div className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all" data-id="element-575">
                <div className="w-14 h-14 bg-pink-100 rounded-xl flex items-center justify-center mb-6 text-pink-600" data-id="element-576">
                  <Gift className="h-7 w-7" data-id="element-577" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-578">
                  Holiday Gifts
                </h3>
                <p className="text-gray-600" data-id="element-579">
                  Custom ornaments, stockings, and holiday apparel that make the
                  season bright and personal.
                </p>
              </div>
              <div className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all" data-id="element-580">
                <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-6 text-purple-600" data-id="element-581">
                  <Heart className="h-7 w-7" data-id="element-582" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-583">
                  Weddings & Baby
                </h3>
                <p className="text-gray-600" data-id="element-584">
                  Monogrammed robes, baby blankets, and keepsakes for life's
                  most beautiful milestones.
                </p>
              </div>
              <div className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all" data-id="element-585">
                <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6 text-teal-600" data-id="element-586">
                  <Sparkles className="h-7 w-7" data-id="element-587" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-588">
                  Just Because
                </h3>
                <p className="text-gray-600" data-id="element-589">
                  Funny mugs, custom tumblers, and tote bags that bring a smile
                  to anyone's face.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-gray-50 py-20" data-id="element-590">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-591">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-592">
              Ready to create something special?
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-593">
              Contact us to discuss your personalized gift ideas. We'll help you
              create the perfect custom item for any occasion.
            </p>
            <a href="/contact" className="inline-flex items-center px-8 py-4 bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-full shadow-lg transition-all" data-id="element-594">
              Contact Us
            </a>
          </div>
        </section>
      </main>

      <Footer data-id="element-595" />
    </div>;
}